import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { PaymentInitStepDeclaration } from "./Steps/PaymentInitStep";

export const PaymentStartupFlow = new FlowDefinition("PaymentFlow");

PaymentStartupFlow.addStep(PaymentInitStepDeclaration);

PaymentStartupFlow.setStartStep("PaymentInit_Step");

export const paymentStartupFlowDefinition = new StepDefinition({
    stepName: "PaymentFlow",
    stepFlow: PaymentStartupFlow,
    contextIsolation: false
})